import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserDto } from 'src/app/model/account/UserDto';
import { RolesEnum } from 'src/app/service/enums/role.enum';
import { BaseComponent } from '../components/base.component';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent extends BaseComponent implements OnInit {
  public uiBasicCollapsed = false;
  public uiAdvancedCollapsed = false;
  public formsCollapsed = false;
  public editorsCollapsed = false;
  public chartsCollapsed = false;
  public tablesCollapsed = false;
  public iconsCollapsed = false;
  public mapsCollapsed = false;
  public userPagesCollapsed = false;
  public errorCollapsed = false;
  public generalPagesCollapsed = false;
  public eCommerceCollapsed = false;

  userprofile: UserDto;
  isSuperAdmin: boolean = false;
  isAccountant: boolean = false;
  isWalkInEmployee: boolean = false;
  isCustomer: boolean = false;
  isRdcAccess: boolean = false;
  isShowCustomersInquiries: boolean = false;
  isShowOrdersServices: boolean = false;
  isShowOrdersServicesAssignment: boolean = false;
  isShowAuditOrdersServicesAssignment: boolean = false;
  constructor(translate: TranslateService) {
    super();
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');
    this.userprofile = this.userProfileService.getProfile();
    this.isSuperAdmin = this.userProfileService.isRoleExists(RolesEnum.SuperAdmin);
    this.isAccountant = this.userProfileService.isRoleExists(RolesEnum.Accountant);
    this.isCustomer = this.userProfileService.isRoleExists(RolesEnum.Customer);
    this.isWalkInEmployee = this.userProfileService.isRoleExists(RolesEnum.WalkInEmployee);
    this.isRdcAccess = this.userProfileService.isRoleExists(RolesEnum.RdcAccess);
    this.isShowOrdersServices = this.userProfileService.isRoleExists(RolesEnum.SuperAdmin) || this.userProfileService.isRoleExists(RolesEnum.WalkInEmployee)
      || this.userProfileService.isRoleExists(RolesEnum.AuditEmployee) || this.userProfileService.isRoleExists(RolesEnum.AuditSupervisor)
      || this.userProfileService.isRoleExists(RolesEnum.Customer) || this.userProfileService.isRoleExists(RolesEnum.Employee)
      || this.userProfileService.isRoleExists(RolesEnum.Manager) || this.userProfileService.isRoleExists(RolesEnum.Supervisor) || this.userProfileService.isRoleExists(RolesEnum.Accountant)
      || this.userProfileService.isRoleExists(RolesEnum.Court);
    this.isShowOrdersServicesAssignment = this.userProfileService.isRoleExists(RolesEnum.SuperAdmin) || this.userProfileService.isRoleExists(RolesEnum.Supervisor);
    this.isShowAuditOrdersServicesAssignment = this.userProfileService.isRoleExists(RolesEnum.SuperAdmin) || this.userProfileService.isRoleExists(RolesEnum.AuditSupervisor);
    this.isShowCustomersInquiries = this.userProfileService.isRoleExists(RolesEnum.SuperAdmin) || this.userProfileService.isRoleExists(RolesEnum.Inquiry);
  }


  ngOnInit() {
    // const body = document.querySelector('body');

    // // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    // document.querySelectorAll('.sidebar .nav-item').forEach(function (el) {
    //   el.addEventListener('mouseover', function () {
    //     if (body.classList.contains('sidebar-icon-only')) {
    //       el.classList.add('hover-open');
    //     }
    //   });
    //   el.addEventListener('mouseout', function () {
    //     if (body.classList.contains('sidebar-icon-only')) {
    //       el.classList.remove('hover-open');
    //     }
    //   });
    // });
  }

  logout() {
    this.userProfileService.clearProfile();
    this.router.navigate(["/account/login"]);
  }

  goToMyProfile() {
    this.router.navigate(["/user/userDetails/" + this.userprofile.id])
  }
}
